<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper/modules";

// CSS ضروري
import "swiper/css";
import "swiper/css/pagination";
</script>

<template>
  <div class="col-xl-4" v-if="streams.length">
    <div class="card card-xl-stretch mb-5 mb-xl-8">
      <!-- Header -->
      <div class="card-header align-items-center border-0 mt-3">
        <h3 class="card-title align-items-start flex-column">
          <span class="fw-bold text-dark fs-3">
            <i
              class="fas fa-broadcast-tower"
              style="
                border-radius: 10px;
                padding: 8px 10px;
                background: #98fd8b6c;
                color: #56c600ff;
              "
            ></i>
            بثوث قد تعجبك
          </span>
          <span class="text-gray-400 mt-2 fw-semibold fs-6">
            تصفح هنا البثوث التي قد تعجبك
          </span>
        </h3>
      </div>

      <!-- Body -->
      <div class="card-body pt-5">
        <div v-if="isLoadingStreams" class="text-center mt-3">
          <span class="spinner-border spinner-border-lg text-success"></span>
          <p>جاري تحميل البثوث...</p>
        </div>

        <div v-else>
          <Swiper
            :modules="[Pagination, Autoplay]"
            :slides-per-view="1"
            :space-between="10"
            :pagination="{ clickable: true }"
            :autoplay="{ delay: 2500, disableOnInteraction: false }"
            loop
            class="mySwiper"
          >
            <SwiperSlide v-for="stream in streams" :key="stream.class_id">
              <div class="d-flex mb-7">
                <div class="d-flex flex-column flex-grow-1 pe-3">
                  <a
                    href="javascript:void(0)"
                    class="fs-5 text-gray-800 text-hover-primary fw-bold"
                  >
                    {{ stream.title }}
                  </a>
                  <span class="text-gray-400 fw-semibold fs-7">
                    <div v-if="isLive(stream)">
                      <b class="badge badge-dark p-2">مباشر الآن</b>
                      <br />
                      <span class="badge badge-secondary text-dark m-1">
                        ينتهي في {{ stream.live_ends_at }}
                      </span>
                      <br />
                      <button
                        class="btn btn-light text-success btn-sm mt-2"
                        @click="joinLiveStream($event, stream.class_id)"
                      >
                        إنضمام
                      </button>
                    </div>

                    <div v-else-if="isEnded(stream)">
                      <b class="badge badge-danger">انتهى البث</b>
                    </div>

                    <div v-else>
                      <b class="badge badge-success">
                        يبدأ في {{ stream.live_starts_at }}
                      </b>
                      <br />
                      <button
                        class="btn btn-light text-success btn-sm mt-2"
                        @click="joinLiveStream($event, stream.class_id)"
                      >
                        إنضمام
                      </button>
                    </div>
                  </span>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
  name: "DashboardView",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      streams: [],
      isLoadingStreams: false,
    };
  },
  mounted() {
    this.getsuggestLive();
  },
  methods: {
    async getsuggestLive() {
      this.isLoadingStreams = true;
      try {
        const response = await fetch(
          `${apiUrl}/livestream/get-similar-courses`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          this.streams = await response.json();
        } else {
          console.error("Failed to fetch live streams");
        }
      } catch (error) {
        console.error("Error fetching live streams:", error);
      } finally {
        this.isLoadingStreams = false;
      }
    },

    async joinLiveStream(event, id) {
      let button = event.target;

      let originalContent = button.innerHTML;

      button.innerHTML = `<span class="spinner-border spinner-border-sm"></span> جاري الانضمام...`;
      button.classList.add("disabled");
      try {
        const response = await fetch(`${apiUrl}/livestream/token/` + id, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        });

        let data = await response.json();

        if (data.token) {
          window.open(
            `https://live.academia.ly/?token=${data.token}`,
            "_blank"
          );
        } else {
          alert("فشل في جلب التوكن، حاول مرة أخرى!");
        }
      } catch (error) {
        console.error("Error fetching token:", error);
        alert("حدث خطأ أثناء الاتصال بالخادم!");
      } finally {
        // إعادة محتوى الزر إلى حالته الأصلية
        button.innerHTML = originalContent;
        button.classList.remove("disabled");
      }
    },
    isLive(stream) {
      const now = new Date();
      return (
        new Date(stream.live_starts_at) <= now &&
        new Date(stream.live_ends_at) >= now
      );
    },
    isEnded(stream) {
      return new Date(stream.live_ends_at) < new Date();
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString("ar-EG", {
        dateStyle: "full",
        timeStyle: "short",
      });
    },
  },
};
</script>

<style scoped>
/* ========== Animations ========== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes liveGlow {
  0%,
  100% {
    box-shadow: 0 0 5px rgba(220, 53, 69, 0.5);
  }
  50% {
    box-shadow: 0 0 20px rgba(220, 53, 69, 0.8);
  }
}

/* ========== Card ========== */
.card {
  border-radius: 20px !important;
  border: 1px solid rgba(0, 196, 68, 0.08) !important;
  background: linear-gradient(145deg, #ffffff 0%, #fafffe 100%);
  box-shadow: 0 8px 32px rgba(0, 196, 68, 0.06);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
  animation: fadeInUp 0.5s ease forwards;
  position: relative;
}
.card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00c444, #00e050, #00c444);
  background-size: 200% 100%;
  animation: shimmer 3s linear infinite;
}
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
.card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 50px rgba(0, 196, 68, 0.15);
  border-color: rgba(0, 196, 68, 0.2) !important;
}

/* ========== Card Header ========== */
.card-header {
  background: transparent;
  border-bottom: 1px solid rgba(0, 196, 68, 0.06);
  padding: 20px 24px;
}

.card-title .fw-bold {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1.1rem;
}
.card-title .fw-bold i {
  width: 42px;
  height: 42px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 12px !important;
  font-size: 1rem;
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e2 100%) !important;
  color: #00c444 !important;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.2);
  transition: all 0.3s ease;
}
.card:hover .card-title .fw-bold i {
  transform: scale(1.1);
}

/* ========== Card Body ========== */
.card-body {
  text-align: right;
  padding: 20px 24px;
}

/* ========== Stream Title ========== */
.card-body .fs-5.fw-bold {
  font-weight: 700 !important;
  color: #1a1a2e;
  transition: color 0.3s ease;
  line-height: 1.5;
}
.card-body .fs-5.fw-bold:hover {
  color: #00c444;
}

/* ========== Badges ========== */
.badge-dark {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
  color: #fff !important;
  padding: 8px 16px !important;
  border-radius: 999px !important;
  font-weight: 600 !important;
  animation: liveGlow 2s ease-in-out infinite;
}

.badge-success {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  color: #fff !important;
  padding: 8px 16px !important;
  border-radius: 999px !important;
  font-weight: 600 !important;
}

.badge-danger {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%) !important;
  color: #fff !important;
  padding: 8px 16px !important;
  border-radius: 999px !important;
  font-weight: 600 !important;
}

.badge-secondary {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  color: #495057 !important;
  padding: 6px 12px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

/* ========== Join Button ========== */
.btn-light {
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e2 100%) !important;
  border: 2px solid rgba(0, 196, 68, 0.2) !important;
  border-radius: 12px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  color: #00c444 !important;
  transition: all 0.3s ease !important;
}
.btn-light:hover {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  color: #fff !important;
  border-color: transparent !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.3);
}

/* ========== Spinner ========== */
.spinner-border {
  color: #00c444 !important;
}

/* ========== Swiper ========== */
.mySwiper {
  padding-bottom: 30px;
}

:deep(.swiper-pagination-bullet) {
  width: 10px;
  height: 10px;
  background: rgba(0, 196, 68, 0.3);
  opacity: 1;
  transition: all 0.3s ease;
}

:deep(.swiper-pagination-bullet-active) {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  width: 24px;
  border-radius: 5px;
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] .card,
[data-theme="dark"] .card,
.dark .card {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%);
  border-color: rgba(0, 196, 68, 0.15) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
[data-bs-theme="dark"] .card:hover,
[data-theme="dark"] .card:hover,
.dark .card:hover {
  box-shadow: 0 20px 50px rgba(0, 196, 68, 0.2);
}

[data-bs-theme="dark"] .card-header,
[data-theme="dark"] .card-header,
.dark .card-header {
  border-color: rgba(0, 196, 68, 0.1);
}

[data-bs-theme="dark"] .card-title .fw-bold,
[data-bs-theme="dark"] .card-title .text-dark,
[data-theme="dark"] .card-title .fw-bold,
[data-theme="dark"] .card-title .text-dark,
.dark .card-title .fw-bold,
.dark .card-title .text-dark {
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .text-gray-400,
[data-theme="dark"] .text-gray-400,
.dark .text-gray-400 {
  color: #b0b3b8 !important;
}

[data-bs-theme="dark"] .card-body .fs-5.fw-bold,
[data-bs-theme="dark"] .text-gray-800,
[data-theme="dark"] .card-body .fs-5.fw-bold,
[data-theme="dark"] .text-gray-800,
.dark .card-body .fs-5.fw-bold,
.dark .text-gray-800 {
  color: #e4e6eb !important;
}
[data-bs-theme="dark"] .card-body .fs-5.fw-bold:hover,
[data-theme="dark"] .card-body .fs-5.fw-bold:hover,
.dark .card-body .fs-5.fw-bold:hover {
  color: #8bffb3 !important;
}

[data-bs-theme="dark"] .badge-secondary,
[data-theme="dark"] .badge-secondary,
.dark .badge-secondary {
  background: linear-gradient(135deg, #3a3b3c 0%, #2d2e30 100%) !important;
  color: #e4e6eb !important;
}

[data-bs-theme="dark"] .btn-light,
[data-theme="dark"] .btn-light,
.dark .btn-light {
  background: linear-gradient(135deg, #1a3d2a 0%, #1e4d35 100%) !important;
  border-color: rgba(0, 196, 68, 0.3) !important;
  color: #8bffb3 !important;
}
[data-bs-theme="dark"] .btn-light:hover,
[data-theme="dark"] .btn-light:hover,
.dark .btn-light:hover {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  color: #fff !important;
}

[data-bs-theme="dark"] :deep(.swiper-pagination-bullet),
[data-theme="dark"] :deep(.swiper-pagination-bullet),
.dark :deep(.swiper-pagination-bullet) {
  background: rgba(0, 196, 68, 0.4);
}
</style>
